// extracted by mini-css-extract-plugin
module.exports = {"Disc":"Disc__Disc__1clKr","DiscHole":"Disc__DiscHole__2UIsl","DiscInfo":"Disc__DiscInfo__1b8N0","DiscNumber":"Disc__DiscNumber__2cwSF","UploadSong":"Disc__UploadSong__1sPC-"};